var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTextItalic = function SvgIconTextItalic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m12.863 6.25-3.834 11.5H6a1 1 0 1 0 0 2h7.5a1 1 0 1 0 0-2h-2.363l3.834-11.5H18a1 1 0 1 0 0-2h-7.5a1 1 0 1 0 0 2z"
  })));
};
export default SvgIconTextItalic;